module.exports = __webpack_public_path__ + "07253ce2.png";